import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import NlpDeploy from './NlpDeploy';
import NLPApiKeys from './NlpApiKeys';
import $ from 'jquery';

class NlpDeployTab extends Component {
  componentDidMount() {
    (function () {
      var currentPath = window.location.href;

      var path = window.origin + "/platform/cloud-nlp/deploy";
      var path1 = window.origin + "/platform/cloud-nlp/deploy/";
      if (currentPath === path || currentPath === path1) {
        $("#apideploy-tab").addClass('active');
      }else if (currentPath.includes("/cloud-nlp/deploy/api-keys") || currentPath.includes("/cloud-nlp/deploy/api-keys/")) {
        $("#api-keys").addClass('active');
      } 
      else {
        $("#" + localStorage.getItem("last-project-settings-tab")).addClass('active')
      }
      $("#apideploy-tab,#api-keys")
        .on("click", function () {
          $("#apideploy-tab,#api-keys")
            .removeClass('active');
          localStorage.setItem("last-project-settings-tab", $(this)[0].id);

          $(this).addClass('active')

        })


    })();
  }
  render() {
    return (

      <div id="tabPage">
        <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

          <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
          <title> Dheeyantra | Clusters Details</title>
          {/* Font Awesome Icons */}
          <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
          {/* IonIcons */}
          <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          {/* Theme style */}
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <div className="content-header" >
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-5">
                  <h1 className="m-0 page-title">Deploy</h1>
                  <h6 className="taglineTxt"></h6>
                </div>

              </div>
            </div>
          </div>
          <div className="container-fluid" >
            {/* Nav tabs */}
            <div className="border-bottom"></div>
            <div className="tab-class">
            
              <ul className="nav nav-tabs border-bottom navCluster">
                <Link to="/cloud-nlp/deploy" style={{ textDecoration: 'none' }}>

                  <li className="nav-item">
                    <a className="nav-link" id="apideploy-tab">Status</a>
                  </li></Link>
                  <Link className="nav-item" data-toggle="tab"
                  to="/cloud-nlp/deploy/api-keys" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="api-keys" style={{ marginRight: '15px' }}>
                    API keys
                  </li>
                </Link>
              </ul>
            </div>
          </div>
        </div>
        <Switch>
        <Route path="/cloud-nlp/deploy/api-keys" component={NLPApiKeys}></Route>
          <Route path="/cloud-nlp/deploy" component={NlpDeploy}></Route>
        </Switch>
      </div>

    );
  }
}
export default NlpDeployTab;


// WEBPACK FOOTER //
// ./src/nlpUi/NlpDeployTab.js